<!--Copyright (c) 2024 FileCloud. All rights Reserved.-->
<template>
  <div class="loader" :class="{ 'loader--full': full, active: loading }">
    <div class="loader-content">
      <LoaderIllustration />
      <p v-if="title" aria-hidden="true">{{ title }}</p>
    </div>
  </div>
</template>
<script>
import LoaderIllustration from '../assets/loader.svg';

export default {
  components: {
    LoaderIllustration,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
